import React, { Component } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
    updateUserProfileAction, updateUserProfileActionWithoutBranch,
    settingsAction,
    getLanguageDataAction, clearStoreData, getEntityDetails, createMandate
} from '../../redux/actions'
import { SimpleUserForm } from '../../components/Forms/PaymentForm'
import UserInfo from '../../components/SideBar/UserInfo.component';
import {
    success as successNotificationAction,
} from 'react-notification-system-redux';

import { notificationOpts } from '../../config'
//session expiry modal
import SessionExpiryModal from './../../components/SessionExpiryModal'
import config from "./../../config/config";
import loadScript from '../OnBorading/Payments'
import { GetSessionValue } from '../../utils/sessionStorage';

let paymentSuccess = true;
let languageData = {}
class UserProfile extends Component {
    state = {
        isDisabled: true,
        btnLabel: 'Update Profile',
        userDetails: '',
        sessionExpiryModal: false,
        apiLoaded: false,
        paymentSuccess: true
    }
    loadScript() {
        // Load the google maps api script when the component is mounted.

        loadScript("https://dropin.gocardless.com/script.js")
            .then((script) => {
                // Grab the script object in case it is ever needed.
                this.script = script;
                this.setState({ apiLoaded: true });
            })
            .catch((err) => {
                console.error(err.message);
            });
    }
    onSubmit = (values, actions) => {
        let { updateUserProfile, successNotification, clearData } = this.props;
        if (values && values.merchantId && typeof (values.merchantId) == 'string') {
            let merchantIds = values.merchantId
            values.merchantId = merchantIds.split(',')
            delete values['merchantIds']
        }
        let body = {
            email: '',
            firstName: '',
            lastName: '',
            phone: '',
            brandName: '',
            address: '',
        }
        if (values) {
            body['email'] = values['email'];
            body['firstName'] = values['firstName'];
            body['lastName'] = values['lastName'];
            body['phone'] = values['phone'];
            body['brandName'] = values['brandName'];
            body['address'] = values['address'];
        }

        if (values['_id']) {
            body['_id'] = values['_id']
            body['brandId'] = values['brandId']
        }

        updateUserProfile(body, (res, type) => {
            let sessionExpiryModal = false
            let sessionExpired = GetSessionValue('sessionExpired')
            if (sessionExpired && (sessionExpired == 'true' || sessionExpired == true)) {
                sessionExpiryModal = true
            }
            this.setState({ sessionExpiryModal: sessionExpiryModal })
            let message
            let details
            if (res && res.details) {
                details = res.details
            }
            if (res && res.respMessage) {
                message = res.respMessage
            } else if (res && res.errorMessage) {
                message = res.errorMessage
            }
            if (actions) {
                actions.setSubmitting(false)
            }
            if (type == 'error') {
                if (actions) {
                    actions.setStatus(message)
                }
                return;
            }
            this.updateUserProfile()
            setTimeout(() => {
                let notification = { ...notificationOpts }
                notification.message = message
                successNotification(notification)
            })
            if (details && details.status && details.status == 'deactivate') {
                clearData(res => {

                })
            }
            this.setState({ isDisabled: true })
        })
    }
    moveToPayment = async () => {
        let { user, successNotification } = this.props
        await this.setState({
            paymentSuccess: false
        })
        paymentSuccess = false;
        this.props.updateUserWithoutBranch({
            stepTwo: true,
            brandId: user.brandId
        })

    }

    updateMandateId = async (self, payerAuthorisationId) => {
        let { user } = self.props;
        if (self.state.payerAuthorisationId) {
            await self.props.createMandateapi({
                payer_authorisations: payerAuthorisationId,
                user: {
                    brandName: user.brandName,
                    brandId: user.brandId,
                    _id: user._id,
                    email: user.email
                }
            }, async (res, type) => {
                self.setState({
                    payerAuthorisationId: ""
                })
                self.props.updateUserWithoutBranch({
                    payerAuthorisationId,
                    brandId: user.brandId
                })
                if (type == 'error') {
                    let sessionExpiryModal = false
                    let sessionExpired = GetSessionValue('sessionExpired')
                    if (sessionExpired && (sessionExpired == 'true' || sessionExpired == true)) {
                        sessionExpiryModal = true
                    }
                    await self.setState({ sessionExpiryModal: sessionExpiryModal })
                }
            })
        }
    }

    gocardlessHandler = () => {
        let gocardlessToken = this.props.settings['gocardlessToken'];
        if (this.state.apiLoaded) {
            let self = this;
            var gocardlessClient = window.GoCardlessClient({
                token: gocardlessToken,
            });
            gocardlessClient.create({
                onSave: function (payerAuthorisationId, confirmCallback, metadata) {
                    // 1. Optional: store the payerAuthorisationId server-side
                    // 2. Mandatory: call confirmCallback to let the Drop-in flow continue
                    confirmCallback();
                    self.setState({
                        payerAuthorisationId
                    })
                },
                onComplete: function (metadata) {
                    paymentSuccess = false;
                    setTimeout(() => {
                        if (self.state.payerAuthorisationId) {
                            self.updateMandateId(self, self.state.payerAuthorisationId)
                        }
                    }, 1000);
                    // The customer completed successfully
                    self.moveToPayment()
                },
                onExit: function (error, metadata) {
                    if (error === undefined) {
                        // The customer left intentionally the Drop-in flow
                        // (for example they closed the modal interface).
                    } else {
                        // The customer left due to unrecoverable error.
                    }
                }
            });
        }
    }
    componentDidMount = () => {
        let { getSettingsData } = this.props;
        let userDetails = GetSessionValue('user')
        if (userDetails && getSettingsData) {
            getSettingsData()
        }

        this.loadScript()
        // this.updateUserProfile()
        this.getDataOfUser();
        this.props.getLanguageData((res) => {

        })
    }
    getDataOfUser = async () => {

        let { user } = this.props
        console.log(user)

        if (user && user['stepTwo'] == true) {
            await this.setState({
                paymentSuccess: false
            })
            paymentSuccess = false
            // this.props.payemnetConfirm();
        }
    }
    updateUserProfile = () => {
        let { getEntityDetails } = this.props
        getEntityDetails(config.entityType, false, async (res, type) => {
            if (type == 'success') {
                await this.setState({ userDetails: res })
            } else {
                let sessionExpiryModal = false
                let sessionExpired = GetSessionValue('sessionExpired')
                if (sessionExpired && (sessionExpired == 'true' || sessionExpired == true)) {
                    sessionExpiryModal = true
                }
                await this.setState({ sessionExpiryModal: sessionExpiryModal })
            }
        })
    }

    formikRef = (e) => {
        this.formik = e
    }

    formikSubmit = () => {
        if (this.formik)
            this.formik.submitForm()
    }

    onToggleEdit = () => {
        let isDisabled = !this.state.isDisabled
        this.setState({ isDisabled })
    }

    getActionBtns = () => {
        if (this.state.isDisabled) {
            return (
                <div className="form-group text-center py-5 my-5">
                    {/* <a href='https://pay-sandbox.gocardless.com/AL00005JTM64BR'>
                        
                    </a> */}
                    {this.props.user.payerAuthorisationId ? <h4 className='text-success'>
                        Your payment details are validated successfully</h4> :
                        // <button className="btn btn-info btn-fill table_action_btn px-5 ml-auto"
                        //     style={{ verticalAlign: 'bottom' }}
                        //     id="pay-with-gocardless-button"
                        //     onClick={this.gocardlessHandler}
                        // >
                        //     Pay with Go CardLess
                        // </button>
                        <div>
                            <button className="btn btn-info btn-fill table_action_btn px-5 ml-auto"
                                style={{ verticalAlign: 'bottom' }}
                                // onClick={this.props.payemnetConfirm}
                                // onClick={this.formikSubmit}
                                id="pay-with-gocardless-button"
                                onClick={() => this.gocardlessHandler()}
                            >
                                Setup Payment with GoCardless
                            </button>
                            <h5 className='text-secondary pt-4'>We will only invoice you
                                for the customer cashback once the campaign
                                has run successfully and our cardholders have transacted at your store.</h5>
                        </div>
                    }
                </div>
            )
        } else {
            return (
                <div className="form-group text-center">
                    <button className="btn btn-info btn-fill btn-wd" onClick={this.formikSubmit}>Update Details</button>
                </div>
            )
        }
    }

    render() {
        let { user } = this.props;
        console.log(this.props)
        return (
            <div className='container  ' >
                <script type="application/javascript" src="https://dropin-sandbox.gocardless.com/script.js"></script>

                <div className="row d-flex justify-content-center align-items-center paymentsHeight"
                // style={{ height: '100vh' }}
                >
                    <div className="col-12 col-md-10">
                        <h3 class="text-center py-3">Payments</h3>
                        <div className="card guestUserCards">

                            <div className=" py-5">
                                {/* <button
                                    id="pay-with-gocardless-button"
                                    onClick={this.gocardlessHandler}
                                >
                                    Pay with GoCardless</button> */}
                                {/* <SimpleUserForm
                                    onSubmit={this.onSubmit}
                                    initialValues={user}
                                    options={{ ...this.state }}
                                    formikRef={this.formikRef}
                                    languageData={languageData}
                                /> */}
                                {this.getActionBtns()}
                            </div>
                            {/* session expiry modal */}
                            <SessionExpiryModal
                                isOpen={this.state.sessionExpiryModal}
                                withoutBrach={true}

                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

export default connect(
    state => ({
        user: state.user,
        settings: state.selectEntities.settingsData
    }),
    dispatch => ({
        updateUserProfile: bindActionCreators(updateUserProfileAction, dispatch),
        updateUserWithoutBranch: bindActionCreators(updateUserProfileActionWithoutBranch, dispatch),
        createMandateapi: bindActionCreators(createMandate, dispatch),
        getLanguageData: bindActionCreators(getLanguageDataAction, dispatch),
        successNotification: bindActionCreators(successNotificationAction, dispatch),
        clearData: bindActionCreators(clearStoreData, dispatch),
        getEntityDetails: bindActionCreators(getEntityDetails, dispatch),
        getSettingsData: bindActionCreators(settingsAction, dispatch),

    })
)(UserProfile);

